import {
  GET_REVENUE_CENTERS_REQUESTED,
  GET_REVENUE_CENTERS_SUCCEEDED,
  GET_REVENUE_CENTERS_FAILED,
  CREATE_REVENUE_CENTERS_REQUESTED,
  CREATE_REVENUE_CENTERS_SUCCEEDED,
  CREATE_REVENUE_CENTERS_FAILED,
  UPDATE_REVENUE_CENTERS_REQUESTED,
  UPDATE_REVENUE_CENTERS_SUCCEEDED,
  UPDATE_REVENUE_CENTERS_FAILED,
  EDIT_REVENUE_CENTER_REQUESTED,
  EDIT_REVENUE_CENTER_SUCCEEDED,
  EDIT_REVENUE_CENTER_FAILED,
  CLEAR_EDIT_REVENUE_CENTER,
  ADD_SERVICE_TYPE_SUCCEEDED,
  CLEAR_SERVICE_TYPES_SUCCEEDED,
  GET_SERVICE_TYPE_FAILED,
  GET_SERVICE_TYPE_REQUESTED,
  GET_SERVICE_TYPE_SUCCEEDED,
  UPDATE_SERVICE_TYPE_REQUESTED,
  UPDATE_SERVICE_TYPE_SUCCEEDED,
  ADD_LOCATION_SETTINGS_SUCCEEDED,
  CLEAR_LOCATION_SETTINGS_SUCCEEDED,
  GET_LOCATION_SETTINGS_FAILED,
  GET_LOCATION_SETTINGS_REQUESTED,
  GET_LOCATION_SETTINGS_SUCCEEDED,
  UPDATE_LOCATION_SETTINGS_REQUESTED,
  UPDATE_LOCATION_SETTINGS_SUCCEEDED,
  ADD_MENU_SETTINGS_SUCCEEDED,
  CLEAR_MENU_SETTINGS_SUCCEEDED,
  GET_MENU_SETTINGS_FAILED,
  GET_MENU_SETTINGS_REQUESTED,
  GET_MENU_SETTINGS_SUCCEEDED,
  UPDATE_MENU_SETTINGS_REQUESTED,
  UPDATE_MENU_SETTINGS_SUCCEEDED,
  GET_AVAILABILITY_REQUESTED,
  GET_AVAILABILITY_FAILED,
  GET_AVAILABILITY_SUCCEEDED,
  SET_SERVICE_TYPES_WITH_ITEMS,
  CLEAR_SERVICE_TYPES_WITH_ITEMS,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_SUCCEEDED,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_REQUESTED,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_FAILED,
} from './constants'
import api, { fetchAvailability } from '../../utils/api'
import { omit } from 'lodash'

export const getRevenueCentersRequested = () => ({
  type: GET_REVENUE_CENTERS_REQUESTED,
})

export const getRevenueCentersSucceeded = (payload) => ({
  type: GET_REVENUE_CENTERS_SUCCEEDED,
  payload,
})

export const getRevenueCentersFailed = () => ({
  type: GET_REVENUE_CENTERS_FAILED,
})

export const createRevenueCentersRequested = () => ({
  type: CREATE_REVENUE_CENTERS_REQUESTED,
})

export const createRevenueCentersSucceeded = (payload) => ({
  type: CREATE_REVENUE_CENTERS_SUCCEEDED,
  payload,
})

export const createRevenueCentersFailed = () => ({
  type: CREATE_REVENUE_CENTERS_FAILED,
})

export const updateRevenueCentersRequested = () => ({
  type: UPDATE_REVENUE_CENTERS_REQUESTED,
})

export const updateRevenueCentersSucceeded = (payload) => ({
  type: UPDATE_REVENUE_CENTERS_SUCCEEDED,
  payload,
})

export const updateRevenueCentersFailed = () => ({
  type: UPDATE_REVENUE_CENTERS_FAILED,
})
export const editRevenueCenterRequested = () => ({
  type: EDIT_REVENUE_CENTER_REQUESTED,
})

export const editRevenueCenterSucceeded = (payload) => ({
  type: EDIT_REVENUE_CENTER_SUCCEEDED,
  payload,
})

export const editRevenueCenterFailed = () => ({
  type: EDIT_REVENUE_CENTER_FAILED,
})
export const clearEditRevenueCenter = () => ({
  type: CLEAR_EDIT_REVENUE_CENTER,
})

export const loadRevenueCenters =
  (venueUuid, includeSettings) => (dispatch) => {
    dispatch(getRevenueCentersRequested())
    return api
      .fetchRevenueCenters(venueUuid, includeSettings)
      .then((response) =>
        dispatch(getRevenueCentersSucceeded(response?.data?.stands))
      )
      .catch(() => dispatch(getRevenueCentersFailed()))
  }

export const createRevenueCenter = (data) => (dispatch) => {
  dispatch(createRevenueCentersRequested())
  return api
    .createRevenueCenters(data)
    .then((res) =>
      dispatch(createRevenueCentersSucceeded(res.data.stands))
    )
    .catch((err) => dispatch(createRevenueCentersFailed(err)))
}

export const updateRevenueCenter = (data) => (dispatch) => {
  dispatch(updateRevenueCentersRequested())

  // Menu Manager should not send the merchant_token in any payload
  const updatedRevenueCenterWithoutMerchantToken = data.map(
    (revenueCenter) => omit(revenueCenter, 'merchantToken')
  )

  return api
    .updateRevenueCenters(updatedRevenueCenterWithoutMerchantToken)
    .then((res) =>
      dispatch(updateRevenueCentersSucceeded(res?.data?.stands))
    )
    .catch((err) => dispatch(updateRevenueCentersFailed(err)))
}

// paginated and filtered Revenue Centers

export const getFilteredAndPaginatedRevenueCentersRequested = () => ({
  type: GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_REQUESTED,
})

export const getFilteredAndPaginatedRevenueCentersSucceeded = (
  payload
) => ({
  type: GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_SUCCEEDED,
  payload,
})

export const getFilteredAndPaginatedRevenueCentersFailed = () => ({
  type: GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_FAILED,
})

export const loadPaginatedAndFilteredRevenueCenters =
  (params) => (dispatch) => {
    dispatch(getFilteredAndPaginatedRevenueCentersRequested())
    return api
      .fetchFilteredAndPaginatedRevenueCenters(params)
      .then((res) =>
        dispatch(getFilteredAndPaginatedRevenueCentersSucceeded(res))
      )
      .catch(() =>
        dispatch(getFilteredAndPaginatedRevenueCentersFailed())
      )
  }

export const createSettings = (data) => () => {
  return api.createSettings(data).then(() => {})
}

// Service Types //

export const getServiceTypeRequested = (payload) => ({
  type: GET_SERVICE_TYPE_REQUESTED,
  payload,
})
export const getServiceTypeSucceeded = (payload) => ({
  type: GET_SERVICE_TYPE_SUCCEEDED,
  payload,
})
export const getServiceTypeFailed = (payload) => ({
  type: GET_SERVICE_TYPE_FAILED,
  payload,
})

export const addServiceType = (payload) => ({
  type: ADD_SERVICE_TYPE_SUCCEEDED,
  payload,
})

export const updateServiceTypeRequested = () => ({
  type: UPDATE_SERVICE_TYPE_REQUESTED,
})
export const updateServiceType = (payload) => ({
  type: UPDATE_SERVICE_TYPE_SUCCEEDED,
  payload,
})

export const clearServiceTypes = () => ({
  type: CLEAR_SERVICE_TYPES_SUCCEEDED,
})

// Service Types With items //

export const setServiceTypesWithItem = (payload) => ({
  type: SET_SERVICE_TYPES_WITH_ITEMS,
  payload,
})

export const clearServiceTypesWithItems = () => ({
  type: CLEAR_SERVICE_TYPES_WITH_ITEMS,
})

// Location Settings //

export const getLocationSettingsRequested = (payload) => ({
  type: GET_LOCATION_SETTINGS_REQUESTED,
  payload,
})
export const getLocationSettingsSucceeded = (payload) => ({
  type: GET_LOCATION_SETTINGS_SUCCEEDED,
  payload,
})
export const getLocationSettingsFailed = (payload) => ({
  type: GET_LOCATION_SETTINGS_FAILED,
  payload,
})

export const addLocationSettings = (payload) => ({
  type: ADD_LOCATION_SETTINGS_SUCCEEDED,
  payload,
})

export const updateLocationSettingsRequested = () => ({
  type: UPDATE_LOCATION_SETTINGS_REQUESTED,
})
export const updateLocationSettings = (payload) => ({
  type: UPDATE_LOCATION_SETTINGS_SUCCEEDED,
  payload,
})

export const clearLocationSettings = () => ({
  type: CLEAR_LOCATION_SETTINGS_SUCCEEDED,
})

// Menu Settings //

export const getMenuSettingsRequested = (payload) => ({
  type: GET_MENU_SETTINGS_REQUESTED,
  payload,
})
export const getMenuSettingsSucceeded = (payload) => ({
  type: GET_MENU_SETTINGS_SUCCEEDED,
  payload,
})
export const getMenuSettingsFailed = (payload) => ({
  type: GET_MENU_SETTINGS_FAILED,
  payload,
})

export const addMenuSettings = (payload) => ({
  type: ADD_MENU_SETTINGS_SUCCEEDED,
  payload,
})

export const updateMenuSettingsRequested = () => ({
  type: UPDATE_MENU_SETTINGS_REQUESTED,
})
export const updateMenuSettings = (payload) => ({
  type: UPDATE_MENU_SETTINGS_SUCCEEDED,
  payload,
})

export const clearMenuSettings = () => ({
  type: CLEAR_MENU_SETTINGS_SUCCEEDED,
})

// Availability //

export const getAvailabilityRequested = () => ({
  type: GET_AVAILABILITY_REQUESTED,
})

export const getAvailabilitySucceeded = (payload) => ({
  type: GET_AVAILABILITY_SUCCEEDED,
  payload,
})
export const getAvailabilityFailed = (payload) => ({
  type: GET_AVAILABILITY_FAILED,
  payload,
})

export const loadAvailaibility = (venuUuid) => (dispatch) => {
  dispatch(getAvailabilityRequested())
  fetchAvailability(venuUuid)
    .then((res) =>
      dispatch(getAvailabilitySucceeded(res?.data?.revenueCenters))
    )
    .catch((err) => dispatch(getAvailabilityFailed(err)))
}
